import React, { useState, useEffect, useContext } from "react";
import { getApiService } from "../services/ApiService";
import { Spinner } from "react-bootstrap";
import { GetPayLoad } from "../services/PayLoadStorage";
import { LanguageContext } from "../contexts/LanguageContext";

const STPS3Details = ({ onApiComplete }) => {
    const Payload = GetPayLoad('PayLoad');
    const [stps3Details, setCaseSTPS3Details] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    };

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }

        const targetCaseAptcUrl = process.env.REACT_APP_API_CASE_APTC_ENDPOINT;
        /* PMO0004087 CHG0127827 SD47534 */
        getApiService(baseUrl, targetCaseAptcUrl, { cim: Payload?.cim, state: Payload?.state, sitecd: Payload?.site_cd, apiSource: 'aptc' }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                } else {
                    setErrorFlag(false);
                    setCaseSTPS3Details(response.data.data);
                }
                if (onApiComplete) onApiComplete();
            })
            .catch(() => {
                setLoading(false);
                setErrorFlag(true);
                if (onApiComplete) onApiComplete();
            });
    }, [pageContent]);

    const STPS3columns = [
        (overViewContent?.overview_aptc_prev_year_total_text || '') + ' (' + (stps3Details?.stps3PreviousYearPeriod || '') + ')',
        (overViewContent?.overview_aptc_current_year_cumulative_text || '') + ' (' + (stps3Details?.stps3CurrentYearPeriod || '') + ')',
        (overViewContent?.overview_aptc_current_amount_text || '') + ' (' + (stps3Details?.stps3CurrentMonth || '') + ')'
    ];

    return (
        <>
            {errorFlag && (
                <div className="api-error-msg">
                    {genericContent?.finance_service_error}
                </div>
            )}

            {isLoading && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                    <Spinner animation="border" role="status" ></Spinner>
                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                </div>
            )}

            {!isLoading && !errorFlag && stps3Details && (
                <div className="bd-example table-responsive aptc-table">
                    <table className="table table-striped aptc-column">
                        {/* PMO0004087 CHG0127827 SD47534 */}
                        <caption style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: '0' }}>
                            {overViewContent?.overview_stps3_title || 'STPS3'}
                        </caption>
                        <thead className="sticky-top aptc-head">
                            <tr className="aptc-header-row">
                                {STPS3columns.map((item) => <th key={item} scope="col">{item}</th>)}
                            </tr>
                        </thead>
                        <tbody className="aptc-tbody">
                            <tr className="aptc-row">
                                <td className="aptc-cell">${stps3Details?.stps3PreviousYearAmount}</td>
                                <td className="aptc-cell">${stps3Details?.stps3CurrentYearAmount}</td>
                                <td className="aptc-cell">${stps3Details?.stps3CurrentAmount}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

export default STPS3Details;